export const truncateString = (word: string, count: number) => {
  if (word.length > count) {
    return word.substring(0, count) + '...'
  }
  return word
}
